export const DUPLICATION_MESSAGE =
  "Please review your submission carefully before proceeding. Submitting the broadcast multiple times or including duplicate records for a patient in your file will result in duplicate messages being sent.";
export const MULTI_LANG_WARNING =
  "This is a multi-language broadcast, please ensure the message is in English only to avoid incorrect translation.";

export const DUPLICATION_REVIEW_MSG =
  "Also please review your submission carefully before proceeding. Submitting the broadcast multiple times or including duplicate records for a patient in your file will result in duplicate messages being sent.";

export const allowOnlyEnglishLetter = (message) => {
  if (!message) {
    return false;
  }

  let normalized = message.trim().replace(/\s+/g, " ");
  normalized = normalized.replace(/[\u200B-\u200D\uFEFF]/g, "");

  if (normalized.length < 32) {
    return false;
  }

  const letterMatches = normalized.match(/[A-Za-z]/g);
  const letterCount = letterMatches ? letterMatches.length : 0;

  if (letterCount < 24) {
    return false;
  }
  const englishOnlyRegex = /^[\x00-\x7F\u2018\u2019\u201C\u201D\u2013\u2014\u2026\u2022\u2032\u2033\u2039\u203A\u00A9\u00AE\u2122\u00A0]*$/;

  return englishOnlyRegex.test(normalized);
};
